import { defineMessages } from '@edx/frontend-platform/i18n';

const messages = defineMessages({
  error404Message: {
    defaultMessage: 'Page not found',
    description: 'Message to display when a user navigates to a page that does not exist',
    id: 'frontend-app-ora.error404Message',
  },
});

export default messages;
